import Box from '@mui/material/Box';

// project imports
import Navigation from './Navigation';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <Box
      component="div"
      role="region"
      aria-label="scrollable content"
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch'
      }}
    >
      <Navigation />
    </Box>
  );
}
